import json from "../../json/subscriptionsGetServersMetaData.json";

type ServerNames =
  | "demo"
  | "demonetherlands"
  | "demohongkong"
  | "demoedgefr"
  | "demoedgeaust";

export default async (data?: object) => {
  const technicalServerNames = (
    data as {
      technicalServerNames: ServerNames[];
    }
  ).technicalServerNames;

  const response = json;
  let currentResponse;
  technicalServerNames.forEach((serverName) => {
    currentResponse = {
      [serverName]: {} as (typeof response)[ServerNames],
    };

    currentResponse[serverName] = response[serverName];
  });

  return JSON.parse(JSON.stringify(currentResponse));
};
